import axios from '@utils/axios';
import { getQueryString } from '@utils/util';

export async function postAuthCodeLogin(params: {
  code: string;
  type: string;
  sys_platform: string;
}): Promise<number> {
  const result = await axios.post(
    '/api/auth/login',
    { ...params },
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );

  return result?.status;
}

export async function postAuthLogin(params: {
  sso_type: string;
  username?: string;
  password?: string;
  invite_code?: string;
  invite_channel?: string;
  sys_platform?: string;
}): Promise<number> {
  const invite_code = getQueryString('invite_code');
  const invite_channel = getQueryString('invite_channel');

  if (invite_code && invite_channel) {
    Object.assign(params, {
      invite_code,
      invite_channel,
    });
  }

  const result = await axios.post(
    '/api/auth/sso_login',
    { ...params },
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );

  return result?.status;
}

export async function postAuthLogout(params: {
  uid: string;
}): Promise<Response> {
  return await axios.post(
    '/api/auth/logout',
    { ...params },
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );
}

export async function postAuthRegister(): Promise<Response> {
  return await axios.post('/auth/register');
}

export async function getAuthVerifyEmail(params: {
  email: string;
}): Promise<string> {
  const result = await axios.get('/api/auth/verify_email', { params });
  return result?.message;
}

export async function deleteAuthAccount(): Promise<number> {
  const result = await axios.delete('/api/auth/delete');
  return result?.status;
}
